/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import localforage from 'localforage';
import { IWidgetGraph } from '../../OnlinePanel/OnlinePanelState';
import { URL_GRAPHS } from '../../../router/constants';
import { getUrl } from '../../Graphs/GraphService';
import { FUEL_LEVEL_LITERS } from '../../OnlinePanel/Widgets/FuelLevelLitersWidget';
import { RPM } from '../../OnlinePanel/Widgets/RpmWidget';
import { BATTERY_VOLTAGE } from '../../OnlinePanel/Widgets/BatteryWidget';
import { isGraphOpenAtom, ordinaryWidgetGraphAtom } from '../../Graphs/GraphState';
import useAnalytics from '../../../hooks/useAnalytics';
import OrdinaryGraphOnline from '../../Graphs/OrdinaryGraph';

export default function OrdinaryWidgetGraph(props: {
  vehicleId: number;
  name: string;
}): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const [ordinaryWidgetGraph, setOrdinaryWidgetGraph] = useRecoilState<IWidgetGraph | null>(
    ordinaryWidgetGraphAtom
  );
  const setIsGraphOpen = useSetRecoilState<boolean | number>(isGraphOpenAtom);

  const closeWidgetGraph = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    trackEvent(['Ordinary Widget', 'click', 'Close widget graph']);
    setOrdinaryWidgetGraph(null);
    localforage.setItem('widgetGraph', null);
    setIsGraphOpen(false);
  };

  const openOrdinaryPage = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    trackEvent(['Ordinary Widget', 'click', 'Open Ordinary page to new window']);
    window.open(`${URL_GRAPHS}${getUrl(props.name)}/${ordinaryWidgetGraph?.vehicleId}`, '_blank');
  };

  const getDate = () => {
    if (ordinaryWidgetGraph && ordinaryWidgetGraph.timestamp) {
      return dayjs(ordinaryWidgetGraph.timestamp).format('DD.MM.YYYY');
    }
    return '';
  };

  React.useEffect(() => {
    trackEvent(['Ordinary Widget', 'show', 'Widget graph']);
    return () => {
      if (ordinaryWidgetGraph && ordinaryWidgetGraph.timestamp !== undefined) {
        setOrdinaryWidgetGraph(null);
        localforage.setItem('widgetGraph', null);
        trackEvent(['Ordinary Widget', 'close', 'Widget graph']);
        setIsGraphOpen(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTitle = () => {
    if (props.name === FUEL_LEVEL_LITERS) {
      return f({ id: 'widget.fuelLevel.tooltip' }, { valueType: 'L' });
    }
    if (props.name === RPM) {
      return f({ id: 'infoWindow.data.engineRpm' });
    }
    if (props.name === BATTERY_VOLTAGE) {
      return f({ id: 'infoWindow.data.voltage' });
    }
    return f({
      id: `graph.${props.name}.page.title`,
    });
  };

  return (
    <div
      className="new-css-wrapper"
      style={{ background: '#fff', borderRadius: '4px', margin: '2px', width: '756px' }}
    >
      <div
        style={{
          padding: '10px 14px 10px 10px',
        }}
      >
        <div className="">
          <div style={{ display: 'inline-flex' }}>
            <a
              href=""
              onClick={closeWidgetGraph}
              className="cmd-icon cmd-icon-arrow-left-ext"
              title={f({ id: 'graph.onlinepanel.back' })}
              style={{
                color: '#494949',
                marginRight: '12px',
                top: '2px',
                position: 'relative',
              }}
            />
            {f({ id: getTitle() })}: {getDate()}
          </div>
          <div
            style={{
              float: 'right',
              padding: '2px 10px',
              textAlign: 'center',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            className="e-button--gray mb-2"
            onClick={openOrdinaryPage}
          >
            {f({ id: 'table.detailBtn' })}
          </div>
        </div>
      </div>
      <div style={{ padding: '0 0 0 10px' }}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <OrdinaryGraphOnline vehicleId={props.vehicleId} name={props.name} />
        </React.Suspense>
      </div>
    </div>
  );
}
